module.exports = __webpack_public_path__ + "assets/img/2w.45bca603.png";